/* eslint-disable no-unused-vars */
import React from 'react';
import { ReactNode } from 'react-transition-group/node_modules/@types/react';
import style from './bubble.module.scss';
import cx from 'classnames';

export default function Bubble(props: {
  children: ReactNode | ReactNode[];
  style?: React.CSSProperties;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}) {
  return (
    <div
      style={props.style}
      className={cx(style.container, props.className, 'noselect')}
      onClick={(e) => {
        props.onClick && props.onClick(e);
      }}
    >
      {props.children}
    </div>
  );
}
